/* eslint-disable no-console */
import { inject, Injectable, InjectionToken, Provider } from '@angular/core';
import { ENVIRONMENT } from '../../../environments/environment.interface';
import { APP_INSIGHTS } from './appinsights.factory';

export const LOGGER = new InjectionToken<LogService>('LOGGER');

@Injectable()
export class LogService {
	private readonly ai = inject(APP_INSIGHTS);
	private readonly env = inject(ENVIRONMENT);

	public log(message: string, logToAppInsights = true, ...optionalParams: unknown[]) {
		try {
			if (logToAppInsights && this.env.configuration !== 'local')
				this.ai.trackTrace(
					{ message, properties: { optionalParams } },
					{
						application: 'klifd-web',
						environment: this.env.configuration,
					},
				);
			if (this.env.showDevTools) {
				console.log(message, ...optionalParams);
			}
		} finally {
			// do not throw errors from logging, if there are errors just continue with the application.
		}
	}

	public warn(message: string, ...optionalParams: unknown[]) {
		try {
			if (this.env.configuration !== 'local') {
				this.ai.trackTrace(
					{ message, properties: { optionalParams } },
					{
						application: 'klifd-web',
						environment: this.env.configuration,
					},
				);
			}
			console.warn(message, ...optionalParams);
		} finally {
			// do not throw errors from logging, if there are errors just continue with the application.
		}
	}

	public error(er: Error, ...optionalParams: unknown[]) {
		try {
			if (this.env.configuration !== 'local') {
				this.ai.trackException(
					{ error: er, properties: { optionalParams } },
					{
						application: 'klifd-web',
						environment: this.env.configuration,
					},
				);
			}
			console.error(er, ...optionalParams);
		} finally {
			// do not throw errors from logging, if there are errors just continue with the application.
		}
	}
}

export const provideLogService: Provider = {
	provide: LOGGER,
	useClass: LogService,
};
